export default (() => ({
  root: {
    marginTop: '16px',
    '& > div': {
      marginBottom: '16px',
    },
  },
}));
